module.exports = __webpack_public_path__ + "img/checked_green.86e2764c.svg";